import { Spin } from "antd";
import ActionMenuV2 from "components/ActionMenuV2";
import AppLoader from "components/AppLoader";
import message from "components/CustomMessage";
import TableContainer from "components/TableContainer";
import { PermissionSetMap } from "constants/RBACConstants";
import { isEmpty } from "lodash";
import React, { useCallback } from "react";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import ModalUtil from "utils/modalUtil";
import { CellRenderers } from "utils/tableUtils";

import { SyncCMDBResourceButton } from "../genericIntegrationTicketUtils";
import DataDogConfigLoginForm, {
  DataDogConfigDataProps,
  DataDogConfigLoginProps,
} from "./DataDogConfigLoginForm";

function DataDogConfigListing({
  name,
  loginConfigList,
  loading,
  ...props
}: DataDogConfigLoginProps) {
  return (
    <>
      {
        <SyncCMDBResourceButton
          toolName={"DATADOG"}
          isDisabled={isEmpty(loginConfigList)}
        />
      }
      <Spin spinning={loading} indicator={<AppLoader />}>
        <ConfigItem loginConfigList={loginConfigList} {...props} />
      </Spin>
    </>
  );
}

const ConfigItem = ({
  loginConfigList,
  deleteAPI,
  enabledAPI,
  name,
  onUpdateConfigComponent,
  ...props
}: DataDogConfigLoginProps) => {
  const onEditLoginConfig = useCallback(
    (record) => {
      ModalUtil.show({
        content: (
          <DataDogConfigLoginForm
            displayName={props.displayName}
            name={name}
            config={record}
            onUpdateConfigComponent={onUpdateConfigComponent}
          />
        ),
      });
    },
    [props.displayName, name, onUpdateConfigComponent],
  );

  const onDeleteConfigLogin = useCallback(
    async (record) => {
      try {
        await ToolsIntegrationsAPI.deleteTicketSystemToolLoginDetails(
          "DATADOG",
          record?.id,
        ).promise;
        onUpdateConfigComponent && onUpdateConfigComponent(true);
        message.success("Configuration deleted successfully");
      } catch (err) {
        console.log(err);
      }
    },
    [onUpdateConfigComponent],
  );

  const actiontems = [
    {
      type: "edit",
    },
    {
      type: "delete",
      permission: PermissionSetMap.DELETE_TOOL,
    },
  ];

  const onActionClick = async (_: any, record: any) => {
    switch (record.name) {
      case "edit":
        onEditLoginConfig(record.data);
        break;
      case "delete":
        await onDeleteConfigLogin(record.data);
        break;
      default:
        break;
    }
  };

  return (
    <>
      <TableContainer
        dataSource={loginConfigList}
        columns={[
          {
            dataIndex: "name",
            title: "Name",
            render: CellRenderers.VALUE_OR_NA,
          },
          { dataIndex: "url", title: "URL", render: CellRenderers.VALUE_OR_NA },
          {
            title: "Action",
            render: (record: {
              name: string;
              data: DataDogConfigDataProps;
            }) => (
              // @ts-expect-error
              <ActionMenuV2
                items={actiontems}
                onClick={onActionClick}
                data={record}
              />
            ),
          },
        ]}
      />
    </>
  );
};

export default DataDogConfigListing;
